<app-side-menu (toggle)="toggleCollapse($event)"></app-side-menu>

<div *ngIf="loading" class="overlay">
  <div class="spinner"></div>
</div>

<body class="green lighten-5" style="min-height: 720px;">
  <div class="navbar" [class.admin-expanded]="isNavbarExpanded">
    <app-navbar></app-navbar>
  </div>

  <div class="main-panel" [class.admin-expanded]="isNavbarExpanded">
    <br />
    <br />
    <br />
    <br />

    <div class="card messages-card">
      <div class="messages-header">
        <h3><b>Messages from procurement</b></h3>
        <h6 class="messages-subtitle">
          Notes added by UNIPET administrators about your vendor registration appear here, newest at the bottom.
        </h6>
      </div>

      <div *ngIf="error" class="alert error" role="alert">{{ error }}</div>

      <ng-container *ngIf="!loading && !error">
        <ul class="message-list" *ngIf="messages.length > 0">
          <li class="message-card" *ngFor="let m of messages">
            <div class="message-meta">
              <span class="message-time">{{ formatWhen(m.createdAt) }}</span>
              <span class="message-sender" *ngIf="m.senderName">From: {{ m.senderName }}</span>
            </div>
            <div class="message-body">{{ m.noteContent }}</div>
          </li>
        </ul>

        <div *ngIf="messages.length === 0" class="messages-empty">
          <p class="messages-empty-text">No messages yet.</p>
        </div>
      </ng-container>
    </div>
  </div>
</body>
